import utils from './utils'
import store from './store'
import data from './data'
import auth from './auth'
import gCalendar from './gCalendar'
import holidayJp from 'holiday-jp'

var app = {
  utils,
  store,
  data,
  auth,
  gCalendar,
  holidayJp
};

export default app;
